import type { RequestBody, Operation } from '@platform/openapi';
import { z } from 'zod';

export const SETTINGS_MANAGE_ROLE = 'settings:manage';

export const CONFIRMATION_WINDOW_HOURS = { min: 1, max: 720 } as const;

export type OrderSettingsBody = RequestBody<Operation<'/admin/tenant/order-settings', 'put'>>;

export const orderSettingsFormSchema = z.object({
  orderConfirmationTtlHours: z
    .number()
    .int()
    .min(CONFIRMATION_WINDOW_HOURS.min)
    .max(CONFIRMATION_WINDOW_HOURS.max),
});

export type OrderSettingsFormValues = z.infer<typeof orderSettingsFormSchema>;
